import { useAppTranslation } from '../i18n/useAppTranslation';
import { useState } from 'react';
import {
  Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Divider,
} from '@mui/material';
import { DeleteForever } from '@mui/icons-material';
import api from '../services/api';

/**
 * Bouton « Supprimer mon compte » (RGPD : droit a l'effacement) avec modale de
 * confirmation. Appelle l'endpoint /users/me/delete/ puis renvoie sur la
 * landing. Masque pour les comptes de demonstration (partages).
 */
export default function DeleteAccountButton() {
  const { tr } = useAppTranslation();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    try {
      await api.delete('/users/me/delete/');
      localStorage.clear();
      window.location.href = '/';
    } catch {
      setLoading(false);
      setError("La suppression a échoué. Réessayez, ou écrivez à contact@g1sport.fr.");
    }
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5, color: '#ef4444' }}>
         {tr("Zone de danger")} </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
         {tr("La suppression de votre compte est définitive et efface toutes vos données.")} </Typography>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteForever />}
        onClick={() => { setError(''); setOpen(true); }}
      >
         {tr("Supprimer mon compte")} </Button>

      <Dialog open={open} onClose={() => !loading && setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#ef4444' }}>
          <DeleteForever />  {tr("Supprimer mon compte")} </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
             {tr("Cette action est")} <b>{tr("définitive")}</b>{tr(". Votre compte et toutes vos données associées (profil, réservations, messages, évaluations) seront")} <b>{tr("supprimés")}</b>  {tr("et ne pourront pas être récupérés.")} </Typography>
          <Typography variant="body2" color="text.secondary">
             {tr("Souhaitez-vous vraiment continuer&nbsp;?")} </Typography>
          {error && (
            <Typography variant="body2" sx={{ color: '#ef4444', mt: 1.5, fontWeight: 600 }}>{tr(error)}</Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpen(false)} disabled={loading}>{tr("Annuler")}</Button>
          <Button
            onClick={handleDelete}
            disabled={loading}
            variant="contained"
            color="error"
            startIcon={<DeleteForever />}
          >
            {loading ? 'Suppression…' : tr("Supprimer définitivement")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
